//
//
//
//
import articleBase from '../articleBase';
export default {
  name: 'active',
  components: {
    articleBase: articleBase
  }
};